import type { Project } from '../modal';
import { useMemo } from 'react';

export const useIsStartStopDisabled = (project: Project | undefined) => {
  const isDisabled = useMemo(() => {
    if (!project) return false;
    return (
      project.status === 'EMPTY' ||
      (project.serviceType === 'compute' && project.status === 'FROZEN')
    );
  }, [project]);

  return isDisabled;
};
